import { render, staticRenderFns } from "./DefaultTableLayout.vue?vue&type=template&id=f8c4add0&scoped=true"
import script from "./DefaultTableLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultTableLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c4add0",
  null
  
)

export default component.exports